import moment from 'moment-timezone'
import React from 'react'
import { translateNode } from 'src/localization/translateNode'
import {
  AccessCodeListModel,
  AccessCodeListResponse,
} from 'src/models/accessCodes.models'

export interface CspUserListResponse {
  lastLogin?: number
  roles: string[]
  companies: string[]
  creditCardCap: {
    current: number
    max: number
  }
  virtualCardCap: Array<{
    last4: string
    current: number
    max: number
  }>
  accessCodes: AccessCodeListResponse[]
}

export class CspUserListModel {
  public lastLogin?: number
  public roles: string[]
  public companies: string[]
  public creditCardCap: {
    current: number
    max: number
  }
  public virtualCardCap: Array<{
    last4: string
    current: number
    max: number
  }>
  public accessCodes: AccessCodeListModel[]

  public constructor(data: CspUserListResponse) {
    this.lastLogin = data.lastLogin
    this.roles = data.roles
    this.companies = data.companies
    this.creditCardCap = data.creditCardCap
    this.virtualCardCap = data.virtualCardCap
    this.accessCodes = data.accessCodes.map(
      (code) => new AccessCodeListModel(code),
    )
  }

  public get formattedLastLogin(): React.ReactElement {
    return this.lastLogin
      ? translateNode('${date} at ${timeLabel}', {
          date: moment.tz(this.lastLogin, moment.tz.guess()).format('l'),
          timeLabel: moment.tz(this.lastLogin, moment.tz.guess()).format('LT'),
        })
      : translateNode('Unknown')
  }
}
